export default class FakeRegisterMessage {
	static protocol = {}

	constructor() {}
}
